// tslint:disable
export enum TCSSiteType {
    /**
     * @description None
     */
    None = -1,
    /**
     * @description Facility
     */
    Facility = 0,
    /**
     * @description Infusion
     */
    Infusion = 1,
    /**
     * @description Pharmacy
     */
    Pharmacy = 2,
}
(TCSSiteType as any)['NONE'] = -1;
(TCSSiteType as any)['FACILITY'] = 0;
(TCSSiteType as any)['INFUSION'] = 1;
(TCSSiteType as any)['PHARMACY'] = 2;
